import React from "react";

const CookiesPolicy = () => {
  return (
    <div
      style={{
        height: "100vh",
        margin: 20,
      }}
    >
      <h1
        style={{
          justifySelf: "center",
          alignContent: "center",
          marginBottom: 10,
        }}
      >
        Cookies Policy
      </h1>
      <p style={styles.paragraph}>
        We do not store sensitive or personal information through cookies; only
        basic details, such as your selected preferences, are saved. Cookies
        store your country or region selection to provide a more personalized
        experience and remember your preferences for future visits. You have
        full control over whether to allow cookies, and while disabling them may
        limit some convenience features, it will not affect your access to the
        website. You can manage your cookie preferences at any time through your
        browser settings.
      </p>
    </div>
  );
};

export default CookiesPolicy;

const styles = {
  paragraph: {
    justifySelf: "left",
    alignContent: "center",
    fontSize: "18px",
  },
};
